<template>
	<div class="wrapper">
		<div class="wrappers">
			<div class="mn">
				<div class="zhanzhuai-guide-tit mb15 cl">
					<div class="guide-topico cl">
						<img src="../../../assets/guide-topico1.png" v-if="listQuery.type==1" alt="">
						<img src="../../../assets/guide-topico2.png" v-if="listQuery.type==2" alt="">
						<img src="../../../assets/guide-topico3.png" v-if="listQuery.type==3" alt="">
						<img src="../../../assets/guide-topico4.png" v-if="listQuery.type==4" alt="">
						<img src="../../../assets/guide-topico5.png" v-if="listQuery.type==5" alt="">
					</div>
					<div class="guide-name-c">
						<div class="guide-name">
							 <el-dropdown placement="bottom-start">
							  <span class="el-dropdown-link">
								{{
									listQuery.type==1?'最新发表':
									listQuery.type==2?'最新评论':
									listQuery.type==3?'精华帖子':
									listQuery.type==4?'我的帖子':
									listQuery.type==5?'抢沙发啦':'请选择'
								}}
								<!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
							  </span>
<!-- 							  <el-dropdown-menu slot="dropdown">
								<el-dropdown-item
								@click.native="dianji(item)"
								v-for="(item,i) in typearr" :key="i"
								>{{item.label}}</el-dropdown-item>
							  </el-dropdown-menu> -->
							</el-dropdown>
						</div>
					</div>
				</div>
				
				<div class="luntan">
					<div class="luntans" v-for="(item,i) in list" @click="succcreate(item.id)" :key="i">
						<div class="luntanss">
							<div class="luntan01">
								<div class="l01">{{item.title}}</div>
								<div class="l02" v-html="item.content">
									
								</div>
								<div class="l03" style="width: 100%;display: flex;align-items: center;">
									<img :src="item.headimgurl" class="l03img"  alt="">
									<div class="zz_post_tname">{{item.nickname}}</div>
									<div class="zz_post_time">发表于：{{item.createTime}}</div>
									<div class="zz_item_info zz_item_info_v">{{item.show}}</div>
									<div class="zz_item_info zz_item_info_r">{{item.pingnum}}</div>
									<div class="zz_post_flink" style="margin-left: auto;">
										# {{item.zhutiName}} #
									</div>
								</div>
							</div>
	<!-- 						<div class="luntan02"
							style="background: url('http://community.metabiz.com.cn/data/attachment/portal/202207/18/005643ex6elifz9ijr767d.png');
							background-size: cover;
							background-repeat: no-repeat;
							background-position: 50% 50%;
							background-color: rgba(120,120,120,0.1);
							"
							>
								
							</div> -->
						</div>
					</div>
	<!-- 				<div class="zhanzhuai-loading">
						亲，已经到底了
					</div> -->
					
				</div>
				<div class="pagination-container">
				  <el-pagination
				    :current-page="listQuery.page"
				    :page-sizes="[10,20,30, 40]"
				    :page-size="listQuery.limit"
				    :total="total"
				    background layout="total, sizes, prev, pager, next, jumper"
				    @size-change="handleSizeChange"
				    @current-change="handleCurrentChange"
				  />
				</div>
			</div>
			<div class="ri">
				<div class="zhanzhuai_pposts_btn cl" @click="fabuxintie">发布新帖</div>
				<div class="zz_jspc_pdiy box p25">
					<div class="zz_section_title">
						热门帖子
					</div>
					<div class="yueduo">
						<div class="yueduos"  v-for="(item,i) in list" @click="succcreate(item.id)" v-if="i<7" :key="i">
							<i></i>
							<div class="yueduos01">
								<div class="zz_recnews_title">{{item.title}}</div>
								<div class="zz_recnews_time">{{item.createTime}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--发布新帖-->
		<save ref="savedata" @succ="succcreate"></save>
		<!--发布新帖-->
	</div>
</template>

<script>
	import { tiezi_list,tiezi_new_list } from "@/api/boke"
	import { getToken } from '@/utils/auth'
	import save from "./components/save.vue"
	export default {
		components:{
			save
		},
		data(){
			return{

				typearr:[
					{value:1,label:'最新发表'},
					{value:2,label:'最新评论'},
					{value:3,label:'精华帖子'},
					{value:4,label:'我的帖子'},
					{value:5,label:'抢沙发啦'}
				],
				
				listQuery:{
					page:1,
					limit:10,
					type:1
				},
				list:[],
				loading:false,
				total:0,
			}
		},
		mounted(){
			this.listQuery.type = this.$route.query.type?this.$route.query.type:1
			let type = this.$route.query.type?this.$route.query.type:1;
			document.title = type==1?'最新发表':type==2?'最新评论':type==3?'精华帖子':type==4?'我的帖子':'抢沙发啦';
			this.tiezi_list();
		},
		methods:{
			succcreate(id){
				this.id = id
				this.$router.push({
					path:"/forumdetail",
					query:{
						id:id
					}
				})
			},
			tiezi_list(){
				this.loading = true
				console.log("this.listQuery.type",this.listQuery.type);
				if(this.listQuery.type==4){
					this.tiezi_new_list();
				}else{
				   tiezi_list(this.listQuery).then(res=>{
				   	this.loading = false
				   	console.log("帖子列表",res.data);
				   	this.total = res.data.total
				   	this.list = res.data.list
				   	if(this.listQuery.type==2){
				   		//this.list = res.data.list.sort(function (a, b) { return b.pingnum - a.pingnum; })   
				   	}
				   	if(this.listQuery.type==3){
				   		this.list = res.data.list.sort(function (a, b) { return b.show - a.show; }) 
				   	}
				   	//4是我的帖子Œ
				   	if(this.listQuery.type==4){
				   		
				   	}
				   	if(this.listQuery.type==5){
				   		this.list = res.data.list.sort(function (a, b) { return a.pingnum - b.pingnum; })   
				   	}
				   }).catch(()=>{
				   	this.loading = false
				   })	
				}
			},
			tiezi_new_list(){
				this.loading = true
				tiezi_new_list(this.listQuery).then(res=>{
					this.loading = false
					console.log("我的帖子",res.data);
					this.total = res.data.total
					this.list = res.data.list
				}).catch(()=>{
					this.loading = false
				})
			},
			compare(key) {
				
			  return function (obj1, obj2) {
			    if (Number(obj1[key]) < Number(obj2[key])) {
			      return -1
			    } else if (obj1[key] === obj2[key]) {
			      return 0
			    } else {
			      return 1
			    }
			  }
			},
			fabuxintie(){
				//需要先选择专题
				if(getToken()){
					this.$refs.savedata.handlecreate(1,{zhuantiid:null});
				}else{
					loginEvent.$emit('loginDialogEvent')
				}
			},
			//下一页上一页操作
			handleSizeChange(val) {//条数
			  this.listQuery.limit = val
			  this.tiezi_list();
			},
			handleCurrentChange(val) {//列数
			  this.listQuery.page = val
			  this.tiezi_list();
			},
			dianji(e){
				console.log(e);
				//如果点击了我的帖子,则需要判断是否登录
				if(e.value==4){
					if(getToken()){
						this.listQuery.type = e.value
						document.title = e.label
						this.listQuery.page = 1
						this.tiezi_new_list();
					}else{
						loginEvent.$emit('loginDialogEvent')
					}
				}else{
					this.listQuery.type = e.value
					document.title = e.label
					this.listQuery.page = 1
					this.tiezi_list()
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	.shangbu{
		height: 40px;
		line-height: 40px;
		padding-left: 10px;
		padding-right: 10px;
		color: #fff;
		font-size:14px;
		border: 1px solid #999;
		text-align: center;
		color: #333;
		border-radius: 4px;
		cursor: pointer;
		margin-right: 10px;
		margin-bottom: 10px;
	}
	.shangbu:hover{
		background: #FFA07A;
		color: #fff;
		border: 1px solid #FFA07A;
	}
	.selects{
		background: #FFA07A;
		color: #fff;
		border: 1px solid #FFA07A;
	}
	.yueduo{
		border-left: 1px solid #EEEEEE;
		.yueduos{
			position: relative;
	        padding: 6px 0 6px 15px;
			cursor: pointer;
			.yueduos01{
				line-height: 24px;
				color: #999;
				.zz_recnews_title{
					font-size: 14px;
					color: #333;
					overflow: hidden;
				}
				.zz_recnews_title:hover{
					color: #FFA07A;
				}
				.zz_recnews_time{
					margin-bottom: 10px;
					font-size: 14px;
					font-style: inherit;
					font-family: Georgia;
				}
			}
			i{
			    width: 5px;
			    height: 5px;
			    background: #fff;
			    border-width: 1px;
			    border-color: #aaa;
			    border-style: solid;
			    border-radius: 100%;
			    position: absolute;
			    z-index: 1;
			    left: -4px;
			    top: 15px;	
			}
		}
		.yueduos:hover{
			i{
				background: #FFA07A;
				border-color: #FFA07A;
			}
		}
	}
	.luntan02{
		    width: 192px;
		    height: 135px;
			margin-left: auto;
	}
	.luntan{
		width: 100%;
		background: #fff;
		border-radius: 4px;
		transition:all .6s ease;
		margin-bottom: 15px;
		cursor: pointer;
		.luntan01{
			.zz_post_flink{
				margin-left: auto;
				height: 25px;
				line-height: 25px;
				font-size: 12px;
				color: #FFA07A;
			}
			.zz_item_info_v{
				float: left;
				margin-left: 25px;
				background: url("../../../assets/p_views.png") no-repeat 0 5px;
			}
			.zz_item_info_r{
				float: left;
				background: url("../../../assets/p_replys.png") no-repeat 0 6px;
			}
			.zz_item_info{
				margin-right: 15px;
				height: 25px;
				line-height: 25px;
				    padding: 0 10px 0 21px;
				    font-size: 12px;
				    color: #748594;
				    display: inline-block !important;
			}
			.l03{
				display: flex;
				align-items: center;
				height: 25px;
				margin-top: 15px;
				.zz_post_time{
					color: #748594;
					font-size: 12px;
					margin-left: 10px;
				}
				.zz_post_tname{
					color: #48494d;
					font-size: 14px;
				}
				.l03img{
					width: 25px;
					height: 25px;
					border-radius: 50%;
					margin-right: 8px;
				}
			}
			.l01{
				margin-bottom: 10px;
				font-size: 18px;
				color: #262626;
				font-weight: 700;
			}
			.l01:hover{
			    color: #FFA07A;
			}
			.l02{
				line-height: 22px;
				margin-bottom: 15px;
				font-size: 14px;
				color: #787878;
				display:-webkit-box;         //将对象作为弹性伸缩盒子模型显示。
						-webkit-box-orient:vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
						-webkit-line-clamp:2;        //限制行数
						overflow:hidden;             //超出部分隐藏
						text-overflow:ellipsis;      //用一个省略号代替超出的内容
			}
		}
		.luntans{
			width: 100%;
			border-bottom: 1px solid #f0f0f0;
			.luntanss{
				width: 810px;
				margin: 0 auto;
				padding: 25px;
				display: flex;
				
			}
		}
	}
	.zhanzhuai-loading{
		padding: 25px;
		    font-size: 14px;
		    color: #999;
		    text-align: center;
	}
	.zhanzhuai-guide-tit{
		position: relative;
		width: 860px;
		height: 105px;
		.guide-name-c{
			position: absolute;
			float: left;
			top: 35px;
			left: 125px;
			width: 130px;
			height: 38px;
			line-height: 38px;
			color: #fff;
			cursor: pointer;
			.guide-name{
				
				    position: absolute;
				    top: 0;
				    font-weight: 700;
				    left: 0;
					.el-dropdown-link{
						width: 200px;
						font-size: 26px;
						    color: #fff;
							display: flex;
							align-items: center;
					}
			}
		}
		.guide-topico{
			img{
				width: 100%;
				height: 105px;
				object-fit: cover;
			}
		}
	}
	.zhanzhuai_pposts_btn{
		width: 100%;
		    height: 50px;
		    line-height: 50px;
		    margin-bottom: 15px;
		    text-indent: 30px;
		    text-align: center;
		    border-radius: 4px;
		    background: #fc7247 url("../../../assets/posts_ico.png") no-repeat 120px 16px;
			color: #fff;
			font-size: 15px;
			text-align: center;
			cursor: pointer;
	}
	.wrapper{
		width: 1200px;
		margin: 0 auto;
		padding-top: 30px;
		.wrappers{
			width: 100%;
			display: flex;
			.mn{
				width: 860px;
				margin-bottom: 10px;
			}
			.ri{
				width: 325px;
				margin-left: auto;
				margin-bottom: 10px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/luntan/luntan/newthread.vue